import { render, staticRenderFns } from "./PageHomeWardrobe.vue?vue&type=template&id=0d5ad614&scoped=true&"
import script from "./PageHomeWardrobe.vue?vue&type=script&lang=js&"
export * from "./PageHomeWardrobe.vue?vue&type=script&lang=js&"
import style0 from "./PageHomeWardrobe.vue?vue&type=style&index=0&id=0d5ad614&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5ad614",
  null
  
)

export default component.exports